import { parseAccountStatement } from "~~/shared/types/account-statement";

export const useAccountStatementStore = defineStore("accountStatement", () => {
  // state
  const customerAccountStatement = ref(null);
  const parsed = ref(null); 
  const entries = ref([]);
  const loading = ref(true);
  const error = ref(null);

  // const customerAccountStatement = computed(() => {
  //   return raw.value ? parseAccountStatement(raw.value) : null;
  // });

  // const entries = computed(() => {
  //   return customerAccountStatement.value?.entries ?? [];
  // });

  // Recursively trim all string values in an object and collapse multiple spaces
  const trimStringsInObject = (obj) => {
    if (obj === null || obj === undefined) return obj;
    
    if (typeof obj === 'string') {
      return obj.trim().replace(/\s+/g, ' ');
    }
    
    if (Array.isArray(obj)) {
      return obj.map(item => trimStringsInObject(item));
    }
    
    if (typeof obj === 'object') {
      const trimmed = {};
      for (const key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          trimmed[key] = trimStringsInObject(obj[key]);
        }
      }
      return trimmed;
    }
    
    return obj;
  };

  const getAccountStatement = async () => {
    const url = `${useCldURLs[CLD_ENV].account.account_statement}`;
    loading.value = true;
    error.value = null;
    
    try {
      const url = `${useCldURLs[CLD_ENV].account.account_statement}`;
      const { data } = await useFetchApi(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }, true);
      // normalize undefined -> null and trim all strings
      const processedData = data?.value ? trimStringsInObject(data.value) : null;
      customerAccountStatement.value = processedData;
      // console.log("getAccountStatement: API SUCCESS:", customerAccountStatement.value);
      return true;
    } catch (err) {
      console.error("getAccountStatement: API ERROR:", err);
      throw err;
    } finally {
      loading.value = false;
    }
  };
const resetAccountStatement = () => {
  customerAccountStatement.value = null;
  parsed.value = null;
  entries.value = [];
  loading.value = true;
  error.value = null;
};
  return {
    // state
    resetAccountStatement,
    loading,
    error,
    customerAccountStatement,
    entries,

    // actions
    getAccountStatement,
  };
});
